import type { taskEither } from "fp-ts";

import type { Constraint } from "../../../entity";

import type { Common, Create, Delete, Get, GetAll, GetPaginated, Update } from "./ios";

import type {
  AuthenticationError,
  NotFoundError,
  UnexpectedError,
  UniqueKeyViolationError,
} from "~/shared/error";

abstract class Provider {
  abstract create(
    params: Create.In,
  ): taskEither.TaskEither<
    UnexpectedError | AuthenticationError | UniqueKeyViolationError<Constraint>,
    Common.Out
  >;
  abstract update(
    params: Update.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, Common.Out>;
  abstract delete(
    params: Delete.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract get(params: Get.In): taskEither.TaskEither<UnexpectedError | NotFoundError, Get.Out>;
  abstract getAll(): taskEither.TaskEither<UnexpectedError, GetAll.Out>;
  abstract getPaginated(
    params: GetPaginated.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetPaginated.Out>;
}

export { Provider };
